module.exports = __webpack_public_path__ + "img/products-1.fa2b1e04.png";